import { render, staticRenderFns } from "./PDialogActions.vue?vue&type=template&id=6189c770"
import script from "./PDialogActions.vue?vue&type=script&lang=js"
export * from "./PDialogActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports